// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__75_gV","col":"styles_col__2hwn_"};